import { render } from "./SaveSalaryOtherComponent.vue?vue&type=template&id=650c56bd&scoped=true"
import script from "./SaveSalaryOtherComponent.vue?vue&type=script&lang=js"
export * from "./SaveSalaryOtherComponent.vue?vue&type=script&lang=js"

import "./SaveSalaryOtherComponent.vue?vue&type=style&index=0&id=650c56bd&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650c56bd"]])

export default __exports__